import { isDrawAvailable, isGameAlmostOver } from '../../../Game/GamePlayerInfo';
import { highestScoringAvailableCard } from '../../../TwoD/Common/CardUtilities';
import WeightedChoiceBase from './WeightedChoiceBase';

export default class ShouldIChooseAdvertisement extends WeightedChoiceBase {

    constructor(gameController, aiPackage) {
        super(gameController, aiPackage);
        this.isDrawAvailable = isDrawAvailable(this._gameData);
        this.isGameAlmostOver = isGameAlmostOver(this._gameData);
        this.highestAvailableData = highestScoringAvailableCard(
            gameController,true, false);
    }

    _novice = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Advertisement', 'Novice');
        let weight = 0;
        this._weight += weight
    }

    _reasonable = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Advertisement', 'Reasonable');
        let weight = 0;
        weight += this.highestAvailableData.maxPoints;
        // consider limit.

        let question = 'Is the game almost over?';
        let answer = false;
        let reasoning = 'If almost over, Advertise!';
        if (this.isGameAlmostOver) {
            answer = true;
            weight += 2;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        question = 'Is my highest possible score greater than 3?';
        answer = false;
        reasoning = `More than 3 and I really should, Max is ${this.highestAvailableData.maxPoints}.`;
        if (this.highestAvailableData.maxPoints > 3) {
            answer = true;
            weight += 1;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        if (weight > 5) {
            weight = 5
        }
        this._weight += weight
    }

    _persistent = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Advertisement', 'Persistent');
        this._reasonable(true);
        if (this._weight < 1) {
            this._weight = 1
        }
    }
    _unreasonable = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Ghost', 'Unreasonable');
        this._reasonable(true);
        if (this._weight < 2) {
            this._weight = 2
        }

    }

    _obsessed = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Ghost', 'Obsessed');
        this._reasonable(true);
        if (this._weight < 3) {
            this._weight = 3
        }
    }
}
